import React from 'react';
import * as convert from 'json-form-data';
import { Form, Field } from 'react-final-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { FormLabel } from '../../Common';
import { FieldWithError } from './FormAdapters';
import SaveButton from './SaveButton';
import ImageForm from './ImageForm';
import BackButton from './BackButton';
import MultiInput from './MultiInput';
import { ComplexLabel } from '../../Common';
import * as offerActions from '../../../redux/newOffer';
import { offer, media, business } from '../../../services/api';
import { AnalyticsService } from '../../../services/AnalyticsService';
import '../../Form.css';

const ImageFormAdapter = ({ input: { onChange, value }, ...rest }) => (
  <ImageForm value={value} onChange={(e) => onChange(e)} />
);

class OfferForm3 extends React.Component<
  { businessId: string; offer: CreateOffer; offerActions: any },
  { submitting: boolean }
> {
  constructor(props) {
    super(props);
    this.state = { submitting: false };
  }

  async finishIt(state) {
    const n: CreateOffer = {
      female_spots: 0,
      male_spots: 0,
      shared_spots: 0,
      ...state,
    };

    if (n.repeat_type === 'none') n.repeat_type = null;
    if (n.female_spots === '') n.female_spots = '0';
    if (n.male_spots === '') n.male_spots = '0';
    if (n.shared_spots === '') n.shared_spots = '0';

    n.is_group = n.is_group || false;

    // Auto-populate require data for gift
    if (['gift', 'sponsored_content'].indexOf(n.type) !== -1) {
      n.female_spots = '1';
      n.male_spots = '0';
      n.shared_spots = '0';

      n.contact_name = '-';
    }

    const igImages = n.images.filter(
      (item) => typeof item.file === 'string' && item.file.substring(0, 4) === 'http'
    );

    this.setState({ submitting: true });

    if (igImages.length !== 0) {
      const data: any = await media.add({
        source: 'urls',
        urls: igImages.map((item) => item.file),
      });
      const info: any = await business.info();
      const userMedia = info.data.media;
      let index = 0;
      n.images = n.images.map((item) => {
        if (typeof item.file === 'string' && item.file.substring(0, 4) === 'http') {
          const userFile = userMedia.find((x) => x.sort === data.data[index].sort);
          const result = { file: userFile.media_id, preview: userFile.path };
          index++;
          return result;
        } else {
          return item;
        }
      });
    }

    n.images = n.images.map((item) => item.file);

    offer
      .createOffer(this.props.businessId, convert(n))
      .then((data) => {
        this.setState({ submitting: false });
        localStorage.removeItem('currentOffer');
        this.props.offerActions.finish();
        AnalyticsService.track('Submit new Offer', { name: n.subtitle });
      })
      .catch((data) => {
        this.setState({ submitting: false });
      });
  }

  render() {
    return (
      <Form
        onSubmit={(state) => this.finishIt(state)}
        initialValues={this.props.offer}
        render={({ handleSubmit, pristine, invalid, values }) => (
          <form onSubmit={handleSubmit}>
            <div style={{ width: '100%' }}>
              <div className="row">
                {this.props.offer.type !== 'job' ? (
                  <div className="col-md-5">
                    {['gift', 'sponsored_content'].indexOf(this.props.offer.type) === -1 ? (
                      <div>
                        <br />
                        <ComplexLabel
                          first="ANYWHERE OFFER"
                          second="(NO SPECIFIC LOCATION TO REDEEM)"
                        />
                        <br />
                        <div className="custom-control custom-switch">
                          <Field
                            name="has_no_location"
                            render={({ input, ...rest }) => (
                              <>
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="customSwitch1"
                                  {...input}
                                />
                                <label className="custom-control-label" htmlFor="customSwitch1" />
                              </>
                            )}
                          />
                        </div>
                        <br />
                      </div>
                    ) : (
                      <div>
                        <ComplexLabel first="PRODUCT SELECTION INSTRUCTIONS" second="(OPTIONAL)" />

                        <FieldWithError
                          name="custom_email_text"
                          component="textarea"
                          rows="3"
                          style={{ width: '100%' }}
                          placeholder="If the model needs to specify product variety, sizing, color, or style choice, give those instructions here."
                        />

                        <br />
                        <br />

                        <FormLabel>MODEL POSTING INSTRUCTIONS</FormLabel>

                        <FieldWithError
                          name="post_instructions"
                          component="textarea"
                          rows="3"
                          style={{ width: '100%' }}
                          placeholder="List all requirements for posting. Include any contest details here."
                        />

                        <br />
                        <br />
                        <br />
                      </div>
                    )}

                    <ComplexLabel first="SOCIAL HANDLES" second="(@yourbrand)" />
                    <br />
                    <Field
                      name="social_mentions"
                      render={({ input, ...rest }) => <MultiInput {...input} />}
                    />
                    <br />
                    <ComplexLabel first="SOCIAL HASHTAGS" second="(#yourbrand #yourlocation)" />
                    <br />
                    <Field
                      name="social_hashtags"
                      render={({ input, ...rest }) => <MultiInput {...input} />}
                    />
                    <br />
                  </div>
                ) : null}

                <div className={(this.props.offer.type !== 'job' ? 'offset-1' : '') + ' col-md-5'}>
                  <br />
                  <ComplexLabel first="OFFER PHOTOS" second="(SHOW OFF YOUR STUFF!)" />
                  <br />
                  <br />
                  <Field name="images" render={(data) => <ImageFormAdapter {...data} />} />

                  <BackButton click={() => this.props.offerActions.moveBack()} />
                  <SaveButton
                    click={handleSubmit}
                    loading={this.state.submitting}
                    last={true}
                    middle={true}
                    ready={true}
                  />
                </div>
              </div>
            </div>
          </form>
        )}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    businessId: state.business.business_id,
    offer: state.newOffer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    offerActions: bindActionCreators(offerActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OfferForm3);
